export default __webpack_public_path__ + "static/media/bgbanner.8b0994bd.jpeg";